import { Injectable }   from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { QuestionBase, QuestionUITypes } from '../../question-base';
import { DynamicQuestions } from '../question/question.service';
import { QuestionRow } from '../../question-row';
import { QuestionCol2 } from '../../question-col2';

@Injectable()
export class QuestionFormControlService {
  constructor() { }
  
  
  public flattenQuestions(questions){
    let flatQuestions = {};
    for( let key in questions ){
      let question = questions[key];
      if(question.uiType == 'row' || question.uiType == 'col2'){
        for( let rowkey in question.questions ){
          let rowQuestion = question.questions[rowkey];
          flatQuestions[rowkey] = rowQuestion;
        }
      }else{
        flatQuestions[key]=question
      }
    }
    
    return flatQuestions;
    
  }

  public generateFormGroup( questionRow: QuestionRow ) : FormGroup {
    let controls: {[key: string] : FormControl} = {};  
    let group : FormGroup;

    let questions = questionRow.getQuestionsFlatArr();
    questions.forEach(( elem ) => {
      if ( 
        elem.questionType != QuestionUITypes.COL2
      ) {      
        controls[elem.key] = new FormControl(elem.getAvailableValue(), elem.getValidators());
        elem.controlAssociated = controls[elem.key];
      }
    });

    group = new FormGroup(controls);

    questions.forEach(( elem : QuestionBase<any> ) => {
      if ( 
        elem.questionType != QuestionUITypes.COL2
      ) {
        controls[elem.key].valueChanges.subscribe( ((formGroup: FormGroup, control: FormControl, questions: DynamicQuestions, question: QuestionBase<any> ) => {
            return ( newValue : any ) => question.liveChange.apply(question, [formGroup, control, questions]);
          })( group, controls[elem.key], questionRow.getQuestionsFlat(), elem )
        );
      }
    });

    questions.forEach(( elem : QuestionBase<any> ) => {
      /* After subscribing the valueChange functions in the last loop,
       * we now update the values to trigger the change functions initially.
       * I have a strong feeling this should be called in a second loop.
       */
      if ( 
        elem.questionType != QuestionUITypes.COL2
      ) {
        controls[elem.key].updateValueAndValidity();    
      }
    });

    return group;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/question-form-control/question-form-control.service.ts